import React from "react"
import _find from "lodash/find"
import _sortBy from "lodash/sortBy";
import trans, { isTrans } from "trans"

import {
    GridCell,
    Button,
    Icon,
} from "@bdfx/mergado-ui-kit"

import PreviewTemplateSVG from "../containers/preview-template-svg";
import { RandomProduct } from "shape-edit/types";
import { TemplateGalleryType } from "./template-gallery";

interface Props {
    isAlt: boolean
    sizeRatio: number
    randomProduct: RandomProduct
    templates: TemplateGalleryType[]
    handleSelectTemplate: Function
}

interface State {
    showMax: number
}

const PAGE_SIZE = 9


class TemplateGalleryRender extends React.PureComponent<Props, State> {
    constructor(props) {
        super(props)

        this.state = {
            showMax: PAGE_SIZE
        }
    }

    render() {
        const { sizeRatio, templates, randomProduct, isAlt } = this.props
        const { showMax } = this.state

        const filteredTemplatesToRender = templates.filter((o: TemplateGalleryType) => {
            return Math.round(10 * o.width / o.height) === Math.round(10 * sizeRatio)
        })

        return <React.Fragment>
            {filteredTemplatesToRender.slice(0, 2 + showMax).map((o: TemplateGalleryType, idx: number) => {
            const translatedName = isTrans(o.trans) ? trans(o.trans) : o.trans
            return <GridCell key={idx} className={'template-thumbnail'} title={`${translatedName} (${o.id})`} onClick={() => this.props.handleSelectTemplate(o.id)}>
                <PreviewTemplateSVG templateGallery={o} randomProduct={randomProduct} isAlt={isAlt} />
            </GridCell>
            })}
            {filteredTemplatesToRender.length > (2 + showMax) &&
                <GridCell col={'1/-1'}>
                    <Button
                        type={'void'}
                        color={'nocolor'}
                        size={'small'}
                        icon={<Icon type={'ellypsis-light'} textFirst={true} text={trans('more')} />}
                        onClick={() => this.setState({ showMax: showMax + PAGE_SIZE })}
                    />
                </GridCell>
            }
        </React.Fragment>
    }
}

export default TemplateGalleryRender